import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { followOnSpotify } from "../lib/spotify";
import { track } from "../lib/analytics";
import { SpotifyIcon, YouTubeIcon } from "./icons/BrandIcons";

const TikTokIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size} aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9V9c-1.3 0-2.5-.4-3.5-1v6.5A5.5 5.5 0 1 1 11 9v2.2a3.3 3.3 0 1 0 2.3 3.1V3h3.2z" />
  </svg>
);
const IgIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width={size} height={size} aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
);

const pill = "inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.03] px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-white/85 transition-transform active:scale-95 hover:border-gold/40 hover:text-gold";

// Compact, reusable follow strip: Spotify • YouTube • TikTok • Instagram • Código List.
export default function FollowStrip({ settings, placement = "strip", showList = true, className = "" }) {
  const s = settings?.socials || {};
  const spotify = settings?.streaming?.spotify;
  const out = (platform, url) => {
    track(`${platform}_click`, { metadata: { placement } });
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div data-testid={`follow-strip-${placement}`} className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="mr-1 text-[11px] font-bold uppercase tracking-[0.25em] text-white/40">Follow DJ Código</span>
      {spotify && <button data-testid={`follow-spotify-${placement}`} onClick={() => followOnSpotify(spotify)} className={pill}><SpotifyIcon size={15} /> Spotify</button>}
      {s.youtube && <button data-testid={`follow-youtube-${placement}`} onClick={() => out("youtube", s.youtube)} className={pill}><YouTubeIcon size={15} /> Subscribe</button>}
      {s.tiktok && <button data-testid={`follow-tiktok-${placement}`} onClick={() => out("tiktok", s.tiktok)} className={pill}><TikTokIcon size={14} /> TikTok</button>}
      {s.instagram && <button data-testid={`follow-instagram-${placement}`} onClick={() => out("instagram", s.instagram)} className={pill}><IgIcon size={14} /> Instagram</button>}
      {showList && <Link data-testid={`follow-list-${placement}`} to="/#join" className={`${pill} border-gold/40 text-gold`}><Mail size={14} /> Código List</Link>}
    </div>
  );
}
